import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline:
          'border-accent/50 text-foreground hover:border-accent hover:bg-accent/10',
        success:
          'border-emerald-500/15 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
        warning:
          'border-amber-500/15 bg-amber-500/10 text-amber-700 dark:text-amber-400',
        info:
          'border-blue-500/15 bg-blue-500/10 text-blue-700 dark:text-blue-400',
        violet:
          'border-violet-500/15 bg-violet-500/10 text-violet-700 dark:text-violet-400',
        accent:
          'border-primary/15 bg-primary/10 text-primary',
        highlight:
          'border-highlight/15 bg-highlight/10 text-highlight',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
